export default "__VITE_ASSET__D6Q8uyo6__"